import { render } from "./IconFileNew.vue?vue&type=template&id=b96fbeb6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFileNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b96fbeb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b96fbeb6', __exports__)) {
    api.reload('b96fbeb6', __exports__)
  }
  
  module.hot.accept("./IconFileNew.vue?vue&type=template&id=b96fbeb6", () => {
    api.rerender('b96fbeb6', render)
  })

}


export default __exports__